module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 18
// module chunks = 0 1